import './Carousel.scss';
import * as bulmaCarousel from 'bulma-carousel';

export default bulmaCarousel;
